import React from 'react';
import classNames from 'classnames';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import { AddCircle } from '@material-ui/icons';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import PropTypes from 'prop-types';
import {
  useDetailListContext,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/DetailList/Layout/DetailListContext';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import fr from 'facet-rest';
import DetailListItem from '../../../Components/DetailListItem';
import styles from './styles';

function DetailListLayout({
  classes,
  className,
}) {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const { onboardingStepResource } = useSurveyContext();
  const hasNewItemRelationship = !!onboardingStepResource.relationship(fr.relationships.newItem.name);

  const {
    handleFetchDetailResource,
    handleClickAddNewItem,
    newItemCollection,
  } = useDetailListContext();

  return (
    <div className={classNames(classes.root, className)}>
      <SurveyStepHeader
        className={classes.header}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <Box className={classes.content}>
        {resource.attr('detailItems').resources().list().map((detailItemResource) => {
          return (
            <DetailListItem
              key={detailItemResource.id()}
              onClick={() => {
                return handleFetchDetailResource(detailItemResource);
              }}
              className={classes.listItem}
              resource={detailItemResource}
              test={'survey-detail-list-item'}
            />
          );
        })}

        <div
          className={classNames(classes.addButtonRow, {
            [classes.addButtonRowHidden]: !hasNewItemRelationship,
          })}
        >
          <Button1
            className={classes.addButton}
            disabled={!newItemCollection}
            color={'secondary'}
            onClick={() => {
              handleClickAddNewItem(newItemCollection);
            }}
            startIcon={<AddCircle />}
            test={'survey-detail-add-list-item-button'}
          >
            {resource.relationship(fr.relationships.newItem.name)?.meta('prompt') || 'Add New Item'}
          </Button1>
        </div>

        {/* ---------- Footer ---------- */}
        <SurveyStepFooter
          className={classes.footer}
          onSubmit={onSubmitMetaForm}
        />
      </Box>
    </div>
  );
}

DetailListLayout.defaultProps = {
  className: '',
};

DetailListLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

DetailListLayout.defaultProps = {
};

export default withStyles(styles)(DetailListLayout);
